import {
  __commonJS
} from "./chunk-BQWMX7FD.js";

// node_modules/enquire.js/src/QueryHandler.js
var require_QueryHandler = __commonJS({
  "node_modules/enquire.js/src/QueryHandler.js"(exports, module) {
    function QueryHandler(options) {
      this.options = options;
      !options.deferSetup && this.setup();
    }
    QueryHandler.prototype = {
      constructor: QueryHandler,
      /**
       * coordinates setup of the handler
       *
       * @function
       */
      setup: function() {
        if (this.options.setup) {
          this.options.setup();
        }
        this.initialised = true;
      },
      /**
       * coordinates setup and triggering of the handler
       *
       * @function
       */
      on: function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
      },
      /**
       * coordinates the unmatch event for the handler
       *
       * @function
       */
      off: function() {
        this.options.unmatch && this.options.unmatch();
      },
      /**
       * called when a handler is to be destroyed.
       * delegates to the destroy or unmatch callbacks, depending on availability.
       *
       * @function
       */
      destroy: function() {
        this.options.destroy ? this.options.destroy() : this.off();
      },
      /**
       * determines equality by reference.
       * if object is supplied compare options, if function, compare match callback
       *
       * @function
       * @param {object || function} [target] the target for comparison
       */
      equals: function(target) {
        return this.options === target || this.options.match === target;
      }
    };
    module.exports = QueryHandler;
  }
});

// node_modules/enquire.js/src/Util.js
var require_Util = __commonJS({
  "node_modules/enquire.js/src/Util.js"(exports, module) {
    function each(collection, fn) {
      var i = 0, length = collection.length, cont;
      for (i; i < length; i++) {
        cont = fn(collection[i], i);
        if (cont === false) {
          break;
        }
      }
    }
    function isArray(target) {
      return Object.prototype.toString.apply(target) === "[object Array]";
    }
    function isFunction(target) {
      return typeof target === "function";
    }
    module.exports = {
      isFunction,
      isArray,
      each
    };
  }
});

// node_modules/enquire.js/src/MediaQuery.js
var require_MediaQuery = __commonJS({
  "node_modules/enquire.js/src/MediaQuery.js"(exports, module) {
    var QueryHandler = require_QueryHandler();
    var each = require_Util().each;
    function MediaQuery(query, isUnconditional) {
      this.query = query;
      this.isUnconditional = isUnconditional;
      this.handlers = [];
      this.mql = window.matchMedia(query);
      var self = this;
      this.listener = function(mql) {
        self.mql = mql.currentTarget || mql;
        self.assess();
      };
      this.mql.addListener(this.listener);
    }
    MediaQuery.prototype = {
      constuctor: MediaQuery,
      /**
       * add a handler for this query, triggering if already active
       *
       * @param {object} handler
       * @param {function} handler.match callback for when query is activated
       * @param {function} [handler.unmatch] callback for when query is deactivated
       * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
       * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
       */
      addHandler: function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);
        this.matches() && qh.on();
      },
      /**
       * removes the given handler from the collection, and calls it's destroy methods
       *
       * @param {object || function} handler the handler to remove
       */
      removeHandler: function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
          if (h.equals(handler)) {
            h.destroy();
            return !handlers.splice(i, 1);
          }
        });
      },
      /**
       * Determine whether the media query should be considered a match
       *
       * @return {Boolean} true if media query can be considered a match, false otherwise
       */
      matches: function() {
        return this.mql.matches || this.isUnconditional;
      },
      /**
       * Clears all handlers and unbinds events
       */
      clear: function() {
        each(this.handlers, function(handler) {
          handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0;
      },
      /*
          * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
          */
      assess: function() {
        var action = this.matches() ? "on" : "off";
        each(this.handlers, function(handler) {
          handler[action]();
        });
      }
    };
    module.exports = MediaQuery;
  }
});

// node_modules/enquire.js/src/MediaQueryDispatch.js
var require_MediaQueryDispatch = __commonJS({
  "node_modules/enquire.js/src/MediaQueryDispatch.js"(exports, module) {
    var MediaQuery = require_MediaQuery();
    var Util = require_Util();
    var each = Util.each;
    var isFunction = Util.isFunction;
    var isArray = Util.isArray;
    function MediaQueryDispatch() {
      if (!window.matchMedia) {
        throw new Error("matchMedia not present, legacy browsers require a polyfill");
      }
      this.queries = {};
      this.browserIsIncapable = !window.matchMedia("only all").matches;
    }
    MediaQueryDispatch.prototype = {
      constructor: MediaQueryDispatch,
      /**
       * Registers a handler for the given media query
       *
       * @param {string} q the media query
       * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
       * @param {function} options.match fired when query matched
       * @param {function} [options.unmatch] fired when a query is no longer matched
       * @param {function} [options.setup] fired when handler first triggered
       * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
       * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
       */
      register: function(q, options, shouldDegrade) {
        var queries = this.queries, isUnconditional = shouldDegrade && this.browserIsIncapable;
        if (!queries[q]) {
          queries[q] = new MediaQuery(q, isUnconditional);
        }
        if (isFunction(options)) {
          options = { match: options };
        }
        if (!isArray(options)) {
          options = [options];
        }
        each(options, function(handler) {
          if (isFunction(handler)) {
            handler = { match: handler };
          }
          queries[q].addHandler(handler);
        });
        return this;
      },
      /**
       * unregisters a query and all it's handlers, or a specific handler for a query
       *
       * @param {string} q the media query to target
       * @param {object || function} [handler] specific handler to unregister
       */
      unregister: function(q, handler) {
        var query = this.queries[q];
        if (query) {
          if (handler) {
            query.removeHandler(handler);
          } else {
            query.clear();
            delete this.queries[q];
          }
        }
        return this;
      }
    };
    module.exports = MediaQueryDispatch;
  }
});

// node_modules/enquire.js/src/index.js
var require_src = __commonJS({
  "node_modules/enquire.js/src/index.js"(exports, module) {
    var MediaQueryDispatch = require_MediaQueryDispatch();
    module.exports = new MediaQueryDispatch();
  }
});
export default require_src();
//# sourceMappingURL=enquire__js.js.map
